module.exports = __webpack_public_path__ + "static/media/ada.d845f58b.png";